import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import styles from '@components/utils/styles';
import PageWrapper from '@rsc/ui-components/page-wrapper';
import breakpoints from '@rsc/ui-components/breakpoints';
import FooterColumn from './FooterColumn';
import DownloadsList from './DownloadsList';
import SocialIcons from './SocialIcons';
import LegalFooter from './LegalFooter';
import CustomerCareList from './CustomerCareList';

const Container = styled.footer`
  background-color: ${styles.colors.gray[900]};
  margin-top: auto;
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  @media (min-width: ${breakpoints.md}) {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

const Footer = () => {
  return (
    <Container>
      <PageWrapper background="inherit">
        <Inner>
          <FooterColumn heading="Customer Care">
            <CustomerCareList />
          </FooterColumn>
          <FooterColumn heading="Downloads">
            <DownloadsList />
          </FooterColumn>
          <FooterColumn heading="Find us on">
            <SocialIcons />
          </FooterColumn>
        </Inner>
        <LegalFooter />
      </PageWrapper>
    </Container>
  );
};

Footer.propTypes = {
  useQueryStringForEmailSignup: PropTypes.bool,
};

Footer.defaultProps = {
  useQueryStringForEmailSignup: false,
};

export default Footer;
